import { render } from "./listeAssign.vue?vue&type=template&id=0f6923cc&ts=true"
import script from "./listeAssign.vue?vue&type=script&lang=ts"
export * from "./listeAssign.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__